import Delegate from 'ftdomdelegate';
import { add, remove, qs } from '@fluorescent/dom';
import { emit } from '@/glow/events';
import { cart } from '@/glow';

import { makeRequest } from '@/lib/xhr';

const selectors = {
  quickAddButton: '[data-quick-add]',
  quantityButton: '[data-quick-add-quantity]',
  quantityInput: '[data-quantity-input]',
};

const classes = {
  loading: 'loading',
  itemAdded: 'item-added',
};

export default function () {
  let productContent;
  const delegate = new Delegate(document.body);
  delegate.on('click', `button${selectors.quickAddButton}`, _handleClick);
  delegate.on(
    'click',
    `button${selectors.quantityButton}`,
    _handleQuantityClick
  );

  function _handleClick(e, target) {
    const {
      quickAdd: handle,
      productId,
      openModal,
      openQuickCart,
    } = target.dataset;
    const quantityEl = qs(selectors.quantityInput, e.target.parentNode);
    const quantity = quantityEl ? quantityEl.value : 1;

    // Open the modal with variant information and a product form
    if (openModal) {
      _openModal({ handle, openQuickCart, quantity });
    } else {
      // Or add directly to cart
      _addToCart({ productId, target: e.target, openQuickCart, quantity });
    }
  }

  function _openModal({ handle, openQuickCart, quantity }) {
    const requestUrl = `${window.theme.routes.products}/${encodeURIComponent(
      handle
    )}?section_id=quick-add-product`;

    makeRequest('GET', requestUrl)
      .then(response => {
        productContent = response;
      })
      .then(() => {
        emit('quick-add:open', null, {
          productContent,
          openQuickCart,
          quantity,
        });
      });
  }

  function _addToCart({ productId, target, openQuickCart, quantity }) {
    add(target, classes.loading);

    cart.addItemById(productId, quantity).then(() => {
      if (openQuickCart) {
        emit('cart:open', null, { flash: productId });
        remove(target, classes.loading);
        add(target, classes.itemAdded);
      } else {
        remove(target, classes.loading);
        add(target, classes.itemAdded);
      }
    });
  }

  function _handleQuantityClick(_, target) {
    const { change } = target.dataset;
    const quantityInput = qs(selectors.quantityInput, target.parentNode);
    const quantity = parseInt(quantityInput.value, 10);

    if (change === 'increment') {
      quantityInput.value = quantity + 1;
    } else {
      quantityInput.value = quantity > 1 ? (quantityInput.value -= 1) : 1;
    }
  }
}
